import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M10.796 6.028C9.588 4.675 7.573 4.31 6.06 5.55c-1.514 1.238-1.727 3.31-.538 4.774l5.274 4.884 5.273-4.884c1.189-1.465 1.002-3.549-.538-4.774-1.54-1.226-3.527-.875-4.735.478Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);